import type { SVGProps } from 'react';
const DawnFlagUA = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-UA_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-UA_svg__a)">
      <path fill="#156DD1" d="M0 8.533h22V0H0z" />
      <path fill="#FFD948" d="M0 16h22V8.533H0z" />
    </g>
  </svg>
);
export default DawnFlagUA;
